import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class FilterConfigsService extends RestfulService<Models.FilterConfig> {

  constructor(private restService: RestService) {
    super(Models.FilterConfig);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('filter-configs');
  }
}

